'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('ipfs-unixfs'),
    UnixFS = _require.UnixFS;

var persist = require('../../utils/persist');

var _require2 = require('ipld-dag-pb'),
    DAGNode = _require2.DAGNode;
/**
 * @typedef {import('../../types').BufferImporter} BufferImporter
 */

/**
 * @type {BufferImporter}
 */


function bufferImporter(_x, _x2, _x3) {
  return _bufferImporter.apply(this, arguments);
}

function _bufferImporter() {
  _bufferImporter = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, block, options) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var buffer;
              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      buffer = _step.value;
                      _context2.next = 3;
                      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        var unixfs, opts;
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                options.progress(buffer.length, file.path);

                                /** @type {import('../../types').PersistOptions} */
                                opts = {
                                  codec: 'dag-pb',
                                  cidVersion: options.cidVersion,
                                  hashAlg: options.hashAlg,
                                  onlyHash: options.onlyHash
                                };

                                if (options.rawLeaves) {
                                  opts.codec = 'raw';
                                  opts.cidVersion = 1;
                                } else {
                                  unixfs = new UnixFS({
                                    type: options.leafType,
                                    data: buffer,
                                    mtime: file.mtime,
                                    mode: file.mode
                                  });
                                  buffer = new DAGNode(unixfs.marshal()).serialize();
                                }

                                _context.next = 5;
                                return persist(buffer, block, opts);

                              case 5:
                                _context.t0 = _context.sent;
                                _context.t1 = unixfs;
                                _context.t2 = buffer.length;
                                return _context.abrupt("return", {
                                  cid: _context.t0,
                                  unixfs: _context.t1,
                                  size: _context.t2
                                });

                              case 9:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });
            _iterator = _asyncIterator(file.content);

          case 5:
            _context3.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 12;
              break;
            }

            return _context3.delegateYield(_loop(), "t0", 9);

          case 9:
            _iteratorAbruptCompletion = false;
            _context3.next = 5;
            break;

          case 12:
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t1 = _context3["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context3.t1;

          case 18:
            _context3.prev = 18;
            _context3.prev = 19;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context3.next = 23;
              break;
            }

            _context3.next = 23;
            return _awaitAsyncGenerator(_iterator.return());

          case 23:
            _context3.prev = 23;

            if (!_didIteratorError) {
              _context3.next = 26;
              break;
            }

            throw _iteratorError;

          case 26:
            return _context3.finish(23);

          case 27:
            return _context3.finish(18);

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  return _bufferImporter.apply(this, arguments);
}

module.exports = bufferImporter;